<template>
    <main-layout>
        <template #header>
            <main-header :title="'장치 목록' | translate" />
        </template>
        <template #toolbar>
            <div class="search-select-wrapper">
                <select-box-filter-group
                    :select-options="selectOptions"
                    @update-select-options="updateSelectOptions"

                />
                <search-bar
                    style="width: 60%;"
                    :placeholder="'임대업체명, 임대업체 코드, 거래처 명, 거래처 코드, 장치 시리얼, 프린터 시리얼' | translate"
                    v-model="searchKeyword" />
            </div>
        </template>
        <template #body>
            <no-library-bagic-table
                :table-body-data="tableBodyData"
                @refresh-data-load="tableDataLoad('')"
                @page-number-plus="pageNumberPlus"
                :disable-button="disableButton"
                :sort-options="sortOptions"
                @sort-options-data-change="sortOptionsDataChange"
            />
            <div class="loading_wrap" v-show="isLoading">
                <div class="loading"></div>
                <div class="loading"></div>
                <div class="loading"></div>
            </div>
        </template>

    </main-layout>
</template>

<script>
/**
 * 장치 목록 컴포넌트입니다
 * 아래와 같은 기능이 있습니다
 * 1. 장치의 사용여부 삭제여부 flag 값을 컨트롤 하고 있습니다
 * 2. 옵션을 선택하는 selectBox 랑 검색할 수 있는 searchBox가 있습니다.
 * 3. 검색을 안하더라도 기본적으로 조회를 합니다.
 * 4. 추가 로드 버튼 클릭시 pageNumber가 증가하면서 추가 데이터를 가져옵니다.
 * 5. sortBy, sortDesc 데이터로 정렬 요청을 보냅니다.
 * 6. 목록을 클릭시 장치 상세 페이지로 이동합니다.
 */
import MainLayout from "@/components/common/layout/MainLayout";
import MainHeader from "@/components/common/layout/MainHeader";
import SearchBar from "@/components/input/SearchBar";
import NoLibraryBagicTable from "@/views/monitoring/deviceList/NoLibraryBagicTable";
import{PATH} from "@/constants";
import SelectBoxFilterGroup from "@/views/monitoring/deviceList/SelectBoxFilterGroup";

export default {
    name: "DeviceList",
    components: {
        SelectBoxFilterGroup,
        MainLayout,
        MainHeader,
        SearchBar,
        NoLibraryBagicTable
    },
    data() {
        return{
            searchKeyword:undefined,//검색어
            isLoading:false, //요청로딩
            tableBodyData:[], //테이블데이터
            disableButton:false,//추가로드버튼 클릭은 막기 위함입니다.
            pageNumber:1, //추가로드를 위한 데이터입니다.
            reqSortOptions:{//정렬 데이터를 요청에 필요한 형태로 변경하기 위함입니다.
              sortBy:undefined,
              sortDesc:undefined
            },
            sortOptions:{},//정렬 데이터를 쉽게 컨트롤하기 위해서 만들었습니다.
            selectOptions:{ //필터의 모든 옵션 값들입니다.
                rentalcompanyId:undefined,
                useYn:undefined,
                deleteYn:undefined,
                installStatus:undefined,
                deviceType:undefined,
                pageSize:15
            }
        }
    },
    watch :{
        /**
         * 검색어를 입력할때가 아닌 enter를 눌렀을때 데이터가 바뀌고
         * watch로 감지하여 요청을 보냅니다.
         */
        searchKeyword:{
            handler() {
                this.pageNumber =1;
                this.sortOptions={}
                this.tableDataLoad('')
            }
        },
        /**
         * 추가로드 버튼 을 클릭시 pageNumber가 변경되는데
         * 그 부분을 감지하여 데이터를 요청합니다.
         */
        pageNumber: {
            handler(newValue,oldValue){
                if(newValue<oldValue) return
                this.tableDataLoad('pageDataAdd')
            }
        },
        /**
         * 필터를 선택할때마다 데이터가 바뀌고 감지하여 요청을 보냅니다.
         */
        selectOptions:{
            deep:true,
            handler() {
                this.pageNumber =1;
                this.sortOptions={}
                this.tableDataLoad('')
            }
        },
        /**
         * 정렬 데이터가 바뀔때 감지하여 요청에 필요한 형태로 데이터를 가공합니다
         * 그리고 reqSortOptions 데이터에 넣고 요청을 보냅니다.
         */
        sortOptions:{
            deep:true,
            handler() {
                const sortBy=[...Object.keys(this.sortOptions)]
                const sortDesc=[...Object.values(this.sortOptions)]
                this.reqSortOptions= {sortBy,sortDesc}
                this.tableDataLoad('')
            }
        },

    },

    methods : {
        /**
         * 옵션 데이터를 변경합니다.
         * @param newValue
         */
        updateSelectOptions(newValue) {
            this.selectOptions=newValue
        },
        /**
         * pageNumber 데이터를 1씩 증가합니다.
         */
        pageNumberPlus(){
            this.pageNumber++
        },
        /**
         * 응답받은 데이터가 없거나 테이블 자체에 데이터가 없을때 추가로드 버튼을 비활성화 합니다.
         * @param reqData
         */
        disableAddLoadButton(reqData){
            this.disableButton=!!reqData && !!reqData.length
        },
        /**
         * 정렬 데이터를 쉽게 컨드롤 하기위해서 객체에 데이터를 넣었습니다.
         * 칼럼이 없을 경우 false
         * 칼럼이 있으면 원래 데이터에서 반대로 변경
         * @param e
         */
        sortOptionsDataChange(e) {
            if(this.sortOptions[e]){
                this.sortOptions={...this.sortOptions, [e]:!this.sortOptions[e]}
            }else{
                this.sortOptions={...this.sortOptions, [e]:true}
            }
        },


        /**
         * 징치 목록에서 테이블 데이터를 얻기위한 요청입니다.
         * 필터 옵션, 검색키워드, 페이지순서, 정렬이 달라지면 데이터 요청을합니다.
         * @param body
         * @returns {Promise<void>}
         */
        async tableDataLoad(name){
            this.isLoading=true;
            const res =await this.$request(`${PATH.MONITORING.DEVICE_LIST}`)
                .setObject({
                    ...this.selectOptions,
                    ...this.reqSortOptions,
                    pageNumber: this.pageNumber,
                    searchKeyword: this.searchKeyword
                })
                .catch((e)=>{
                    this.isLoading =false;
                    alert('조회실패')
                })
                .enqueue()
            this.disableAddLoadButton(res.data)
            this.tableBodyData = name ? //추가로드 클릭시 데이터 추가저장
                [...this.tableBodyData,...res.data]
                :[...res.data]
            this.isLoading = false;
        },

    },
    created() {
        this.tableDataLoad('')
    }
}
</script>

<style scoped>
.loading_wrap {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    background: rgba(0,0,0,0.5);
}

.loading {
    width: 8px;
    height: 8px;
    background: #aaaaaa;
    border-radius: 50%;
    animation: loading-cricle 1.5s infinite ease-in-out;
    display: inline-block;
    margin-right: 8px;
}

.loading:nth-child(2) {
    animation-delay: .5s;
}

.loading:nth-child(3) {
    animation-delay: 1s;
}
@keyframes loading-cricle {
    0% {
        opacity: .4;
        transform: scale(1, 1);
    }
    50% {
        opacity: 1;
        transform: scale(1.2, 1.2);
    }
    100% {
        opacity: .4;
        transform: scale(1, 1);
    }
}
/*Search Box 부분 font 랑 사이즈 조정 부분입니다*/
>>> .v-input__control .v-input__slot .v-text-field__slot input{
    font-size: 11px;
    padding: 0;
}

>>> .v-input__control .v-input__slot fieldset{
    height: 47px;
}
/*search 부분이랑 select 부분 wrapper입니다*/
.search-select-wrapper{
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;

}



</style>